<template>
    <div  >
<!--        {{active}}-->
        <!--            <select-teacher @onSelect="changeTeacher" :defaultValue="schedule && schedule.teacher"/>-->
       <div v-if=" user.role === 'ADMIN'" class="item p-grid p-col">
           <div v-if="loading" style="padding: 7px !important" v-bind:class="`p-dropdown-item ${getSubjectClass}`">
               -
           </div>
           <Inplace  v-if="!loading "   v-bind:class="getSubjectClass" @cancel="cancelSchedule('LESSON')" @close="postSchedule('LESSON')"
                     cancelble closeIcon="pi-check"
                     :closable="true">
               <template #display>
                   {{ getLessonName(subject) }}
               </template>
               <template #content>
                   <select-lesson  v-on:onSelect="changeLesson" :defaultValue="subject"/>
               </template>
           </Inplace>
       </div>
        <div v-else class="item p-grid p-col" >
            <div v-if="loading" style="padding: 7px !important" v-bind:class="` ${getSubjectClass}`">
                -
            </div>
            <div v-else  style="padding: 7px !important" v-bind:class="` ${getSubjectClass}`">
                {{ getLessonName(subject) }}

            </div>

        </div>
        <div v-if=" user.role === 'ADMIN'" class="item p-grid p-col">
            <div v-if="loading" style="padding: 7px !important" v-bind:class="`p-dropdown-item ${getTeacherClass}`">
                -
            </div>
            <Inplace  v-if="!loading "  v-bind:class="getTeacherClass"  @open="openTeacherSelect" @cancel="cancelSchedule('TEACHER')" @close="postSchedule('TEACHER')"
                      cancelble
                      closeIcon="pi-check" :closable="true">
                <template #display>
                    <div>
                        {{ getTeacherName(teacher) }}

                    </div>
                </template>
                <template  #content>
<!--                    :replace-options="getDisabledGrades"-->
                    <select-teacher v-if="user.role === 'ADMIN'" v-on:onSelect="changeTeacher" :defaultValue="teacher"/>
                </template>
            </Inplace>
        </div>

        <div v-else class="item p-grid p-col" >
            <div v-if="loading" style="padding: 7px !important" v-bind:class="`  ${getTeacherClass}`">
                -
            </div>
            <div v-else  style="padding: 7px !important" v-bind:class="` ${getTeacherClass}`">
            {{ getTeacherName(teacher) }}
            </div>

        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import SelectLesson from "@/components/selects/SelectLesson";
import SelectTeacher from "@/components/selects/SelectTeacher";
import {getLessonFullName, getLessonShortName, getTeacherFullName, getTeacherShortName} from "@/utils/parseObj";

import Service from "@/service/Service";
import {getGradeScheduleByDayAndLesson} from "@/views/Schedule/Schedule";


export default {
    service: null,
    name: "ScheduleItem",
    components: {
        SelectLesson,
        SelectTeacher
    },
    props: {
        schedule: {
            type: Object,
            default: null
        },
        day: {
            type: Object,
            default: null
        },
        lesson: {
            type: Object,
            default: null
        },
        grade: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    watch: {

        // grade(newValue, oldValue) {
        //     Vue.$nextTick(() => {
        //         this.$refs.aaa.aaa()
        //         this.active = false
        //
        //     });
        //     // this.$refs.aaa.aaa()
        //     // setTimeout(()=>{
        //     //     this.active = true
        //     //
        //     //
        //     // },1000)
        //     // setTimeout(()=>{
        //
        //     //
        //     //
        //     //
        //     // },3000)
        //
        // },
        schedule(newValue, oldValue) {
            this.originalSubject = this.schedule?.subject ?? null
                 this.originalTeacher = newValue?.teacher ?? null
                this.subject = newValue?.subject ?? null
                this.teacher = newValue?.teacher ?? null
                this.newSubject = null
                this.newTeacher = null
        }
    },
    computed: {
        getDisabledGrades(){
            //   console.log("((", this.isMultipleAllow ? [] : this.disabledGrades)
            //   this.selectGradeKey++
            // return this.isMultipleAllow ? [] : this.disabledGrades
            return []
        },
        getSubjectClass() {
            let style = "lesson p-col-12 p-p-0"
            if (this.subject === null || this.loading) {
                style += " lesson-blank"
            }
            return style


        },
        getTeacherClass() {
            let style = "teacher p-col-12 p-p-0 "
            if (this.teacher === null || this.loading) {
                style += " teacher-blank"
            }
            return style
        },
        ...mapState(["subjectLesson","user"]),
    },
    data() {
        return {
            active: false,
            originalSubject: this.schedule?.subject ?? null,
            originalTeacher: this.schedule?.teacher ?? null,
            subject: this.schedule?.subject ?? null,
            teacher: this.schedule?.teacher ?? null,
            // originalSubject : JSON.parse(JSON.stringify(this.schedule.lesson)),
            newSubject: null,
            newTeacher: null,
            disabledTeachers: []
            // originalSchedule: JSON.parse(JSON.stringify(this.schedule)),
            // newSchedule: JSON.parse(JSON.stringify(this.schedule))
        }
    },
    methods: {
        async updateDisabledTeachers(){
            this.disabledTeachers = await  getGradeScheduleByDayAndLesson(this.day.id, this.lesson.id)
        },
        changeTeacher(event) {
            this.newTeacher = event
        },
        changeLesson(event) {
            this.newSubject = event
        },
        getLessonName(id) {
            if (id && !this.loading) return getLessonShortName(id)
            return "-"
        },
        getTeacherName(id ) {
            if (id && !this.loading) return getTeacherShortName(id)
            return "-"

        },
       async postSchedule(eventType) {

            const _id = {
                grade: this.grade,
                lesson: this.lesson.id,
                day: this.day.id
            }

            const postObject = {_id}
            if (eventType === "LESSON") {
                postObject.subject = this.newSubject.id
                postObject.teacher = this.teacher
            }
            if (eventType === "TEACHER") {
                postObject.teacher = this.newTeacher || null
                postObject.subject = this.subject || null
            }

            try {
                if (eventType === "LESSON") {
                    this.subject = this.newSubject.id
                }
                if (eventType === "TEACHER") {
                    this.teacher = this.newTeacher
                }
                await  this.service
                    .update(postObject, "schedule")

            } catch (e) {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `העדכון לא נקלט במערכת`
                );
                this.cancelSchedule(eventType)
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
        openTeacherSelect(){
            this.updateDisabledTeachers()

        },
        cancelSchedule(eventType) {
            if (eventType === "LESSON") {
                this.subject = this.originalSubject
            }
            if (eventType === "TEACHER") {
                this.teacher = this.originalTeacher
            }
        }
    },
    created() {
        this.service = new Service();
    }

}
</script>

<style scoped>

.item {
    text-align: center;
    background: #f8fff3;
    margin-right: 1px;
}

.lesson{
    background: #ffffe3;
    font-weight: bold;

}

.teacher{
    background: #ebedfc;
    font-weight: bold;

}
.teacher-blank {
    background: #e8e8e8;
}

.lesson-blank {
    background: #e8e8e8;
}
</style>